export const generatePublicUrl = (fileName) => {
  return `https://api.mentorx4u.com/public/${fileName}`;
};
